import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import viewRelatedAppCategories from '../viewRelatedAppCategories';
import formAppConfigContent from './formAppConfigContent';
import formAppConfigContentMassUpdate from './formAppConfigContentMassUpdate';

export default {
  attributeName: 'appConfigContentTable',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  secondaryButtonText:'Mass update',
  popupContentFormNew:[formAppConfigContent],
  popupContentFormEdit:[formAppConfigContent],
  popupContentFormSecondary:[formAppConfigContentMassUpdate],
  contentFormUrl:'liveAppContent',
  
  editURL:'liveAppContent',
  getURL:'liveAppContent',
  updateURL:'liveAppContent',
  removeURL:'liveAppContent',
  secondaryParamUrl:'massUpdate',

  deleteRecordText:"You are about to delete the content from this live. Are you totally sure?",
  sessionParams: [],
  emptyMessage: "You don't have app contents linked with this live event, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT,
      canOrder: false,
      canFilter:false,
      helpText: 'Content id.',
    },
    {
      attributeName: 'appName',
      label: 'App name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: false,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'configName',
      label: 'Config name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: false,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'name',
      label: 'Content name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: false,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'url',
      label: 'Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canOrder: false,
      canFilter: false,
      helpText: 'Name of the Url.',
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      helpText: 'Activation of content.',
    },
    {
      attributeName: 'startEpoch',
      label: 'Starting',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      canFilter: false,
      helpText: 'Activation of content.',
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      canFilter:false,
      helpText: 'Expiration of the content.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.PLAYERICONS,
      canOrder: false,
      canFilter: false,
      helpText: 'Status of live event.',
    },
    {
      attributeName: 'contentLink',
      label: 'Content link',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Go to content page.',
    },    
  ],
};
